import type { AgentConfigContact } from '@bb/domain/dist/types/AppointmentConfig';
import axios from 'axios';

const getTeamDefaultContact = async (teamId: string) => {
  const { data } = await axios.request<AgentConfigContact[]>({
    url: `/team/default/contact/${teamId}`,
    method: 'get',
  });

  return data;
};

export default getTeamDefaultContact;
